const PriceSeparator = [
  {
    text: '. (DOT)',
    value: '.',
    example: '1.234.567,89',
  },
  {
    text: ', (COMMA)',
    value: ',',
    example: '1,234,567.89',
  },
  {
    text: 'SPACE',
    value: 'space',
    example: '1 234 567.89',
  },
  {
    text: 'NONE',
    value: 'none',
    example: '1234567.89',
  },
];

export default PriceSeparator;
